<template>
  <acclaro-datatable
    ref="acclaroSearchView"
    grid-title="Purchase Orders"
    search-route="/datatables/purchase-orders"
    datatable-name="purchaseorder"
    :search-param="options.searchParam"
    :filter-param="options.filtersParam"
    search-placeholder="Filter Purchase Orders..."
    :column-templates="templates">

    <template v-slot:buttons>
      <!-- v-if="searchType !== 'reviewers' && ! isReviewerOnly && !isAdmin" -->

      <a>
        <button onclick="newRecord()" class="create-order-btn">
          <i title="Create PO" class="acclaro-icon ai-add"></i>
          <span>Create New PO</span>
        </button>
      </a>
    </template>

    <template v-slot:aggregates="props">
      <ul>
        <li><strong>PO Count:</strong> {{ props.aggregates.total || 0 }}</li>
        <li><strong>PO Balance:</strong> {{ strToPrice(props.aggregates.balance) }}</li>
        <li><strong>PO Budget:</strong> {{ strToPrice(props.aggregates.budget) }}</li>
      </ul>
    </template>
  </acclaro-datatable>
</template>

<script>
import Vue from 'vue';
import {EventBus} from "../../event-bus";

import {
  AsEditable,
  AsCell
} from '../Acclaro-Datatable/cells';

export default {

  props: {

    options: {
      type: Object,
      required: true
    }
  },

  data () {
    return {

      activePurchaseOrders: {}
    }
  },

  mounted () {
    EventBus.$on('purchase-order-datatable:update', (currentPage) => {
      //this.$refs.acclaroSearchView.refreshTable();
      location.reload();
    });
  },

  computed: {

    datatableOptions () {
      return {
        cellClasses: {
          "POBalance": [
            {
              class: 'red',
              condition: row => row.POBalance.includes('-')
            }
          ]
        }
      };
    },

    templates () {
      let $vm = this;

      return {
        Description: function (h, row, index) {
          const props = { row, column: 'Description' };

          return (
            <AsEditable
              props={props}
              isTextInput={true}
              updateColumn={'notes'}
              onUpdated={$vm.poCellUpdated}
            />
          );
        },

        'PO Balance': function (h, row, index) {
          const props = {row, column: 'PO Balance'};
          const { balance } = row;

          let $content = balance;

          // https://matanya.gitbook.io/vue-tables-2/conditional-cell-styling
          if (balance && balance.includes('-')) {
              $content = (<span class="red">{balance}</span>);
          }

          return (
            <AsCell props={props}>
              {$content}
            </AsCell>
          );
        },

        'PO Amount': function (h, row, index) {
          const props = { row, column: 'PO Amount' };
          return (
            <AsEditable
              props={props}
              updateColumn={'budget'}
              onUpdated={$vm.poCellUpdated}
            />
          );
        },

        'Active': function (h, row, index) {
          const props = { row, column: 'Active' };

          function update ($event) {
            let isActive = $event.target.checked;

            $vm.activeStateUpdated(row.id, isActive).then(result => {
              //console.log('the result', result)
            })
          }

          return (
            <AsCell class={'align-text-center'} props={props}>
              <input name={'active_' + row.id} type="checkbox" checked={row.is_active} onInput={update}  />
            </AsCell>
          );
        },

        'Order IDs': function (h, row, index) {
          const props = { row, column: 'Order IDs' };
          const orderIds = row['Order IDs'];

          return (
            <AsCell props={props}>
              <span
                v-tooltip={{content: $vm.stripHTMLTags(orderIds)}}
                class="ellipsis something"
                domPropsInnerHTML={orderIds || '-'}></span>
            </AsCell>
          );
        }
      };
    }
  },

  methods: {

    poCellUpdated (packet) {
      let {id, column, value: val} = packet;
      let update = "po-tracker";

      axios.post('/purchase-orders/update', {
        id, update, column, val
      }).then(() => {
        this.$refs.acclaroSearchView.refreshTable();
      });
    },

    activeStateUpdated (id, isActive) {
      return axios.post('/purchase-orders/update', {
        id,
        column: 'is_active',
        val: isActive
      }).then((result) => {
        this.$refs.acclaroSearchView.refreshTable();

        return result;
      });
    },

    strToPrice (amount) {
      let amountFloat = parseFloat(amount);

      if (isNaN(amountFloat) || amountFloat == 0) {
        return '-';
      }

      return '$' + (this.numberWithCommas(amountFloat.toFixed(2)));
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    stripHTMLTags (str = '') {
      if (!str) return;

      return str.replace(/(<([^>]+)>)/gi, "");
    },
  },
}
</script>
